import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { onMounted, onUnmounted } from 'vue'
import { useCartStore } from '@/stores/cart'
import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'
import { useFavoriteStore } from '@/stores/favorite'
import { ElMessage } from 'element-plus'
import { recordVisit } from '@/api/promotion'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const cartStore = useCartStore()
const userStore = useUserStore()
const systemStore = useSystemStore()
const favoriteStore = useFavoriteStore()

onMounted(() => {
  // 初始化应用
  initApp()

  // 监听网络状态
  window.addEventListener('online', handleOnline)
  window.addEventListener('offline', handleOffline)

  // 监听页面可见性
  document.addEventListener('visibilitychange', handleVisibilityChange)
})

onUnmounted(() => {
  window.removeEventListener('online', handleOnline)
  window.removeEventListener('offline', handleOffline)
  document.removeEventListener('visibilitychange', handleVisibilityChange)
})

const initApp = async () => {
  // 初始化购物车
  cartStore.loadCart()

  // 初始化用户信息
  if (userStore.token && userStore.userInfo) {
    userStore.init()
    if (userStore.isLoggedIn) {
      favoriteStore.loadFavorites()
    }
  }

  // 加载系统配置
  systemStore.init()

  // 检测推广分享链接访问：仅未登录用户才有效
  const params = new URLSearchParams(window.location.search)
  const shareCode = params.get('ref')
  if (shareCode && !userStore.isLoggedIn) {
    // 持久化 shareCode，注册/首次登录时使用
    sessionStorage.setItem('promotion_share_code', shareCode)
    // 上报访问记录
    try {
      await recordVisit({
        shareCode,
        visitorDevice: navigator.userAgent,
        referrerUrl: document.referrer || undefined
      })
    } catch (e) {
      // 静默失败，不影响正常访问
    }
  }
}

const handleOnline = () => {
  ElMessage.success('网络连接已恢复')
}

const handleOffline = () => {
  ElMessage.warning('网络连接已断开')
}

const handleVisibilityChange = () => {
  if (document.hidden) {
    // 页面不可见
    console.log('页面隐藏')
  } else {
    // 页面可见
    console.log('页面显示')
    // 可以在这里刷新数据
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})